export default {
  // 导航
  nav_home: '首页',
  nav_anime: '动画库',
  nav_manga: '漫画',
  nav_article: '文章资讯',
  nav_about: '关于我们',
  nav_search_placeholder: '搜索动漫、漫画、文章…',
  nav_search: '搜索',
  nav_menu: '菜单',

  // 首页
  hero_badge: '2026 秋季新番热映中',
  hero_title_1: '一站式追番',
  hero_title_2: '尽在动漫网',
  hero_subtitle: '收录日漫、国漫、新番与漫画分类大全，聚合全站优质资源，帮你快速找到想看的作品，找番追更更省力。',
  hero_cta_primary: '开始找番',
  hero_cta_secondary: '浏览动画库',
  hero_stat_works: '收录作品',
  hero_stat_members: '活跃用户',
  hero_stat_tags: '细分标签',

  sec_new_season: '新番速递',
  sec_new_season_desc: '每季为你抢先整理值得关注的动画新作',
  sec_anime_library: '热门动画库',
  sec_anime_library_desc: '按分类快速浏览，热门作品一网打尽',
  sec_manga: '漫画分类大全',
  sec_manga_desc: '少年漫、少女漫、青年漫……总有一款适合你',
  sec_ranking: '全站人气榜',
  sec_ranking_desc: '实时更新的追番人气与热度排行',
  sec_article: '文章资讯',
  sec_article_desc: '新番前瞻、作品盘点、深度解读',
  sec_more: '查看更多',
  sec_all: '查看全部',

  // 通用
  tag_ranking: '热度',
  tag_year: '年份',
  tag_status: '状态',
  tag_episode: '话',
  tag_rating: '评分',
  tag_new: '新',
  tag_hot: '热',
  tag_finished: '已完结',
  tag_airing: '连载中',
  tag_not_start: '未开播',
  tag_episodes: '全 {count} 话',
  btn_detail: '查看详情',
  btn_back_home: '返回首页',

  // 分类页
  cat_title: '动漫网全部动漫列表',
  cat_subtitle: '支持按日漫、国漫、新番、漫画分类快速筛选，一站直达你想看的作品',
  cat_all: '全部',
  cat_total: '共 {count} 部作品',
  cat_empty: '该分类下暂时没有作品',
  cat_pagination_prev: '上一页',
  cat_pagination_next: '下一页',
  cat_page_info: '第 {page} / {total} 页',
  cat_anime: '动画',
  cat_manga: '漫画',
  cat_breadcrumb_home: '首页',

  // 文章
  art_latest: '最新文章',
  art_related: '相关作品',
  art_author: '作者',
  art_time: '发布于',
  art_category: '分类',
  art_share: '分享',
  art_back: '返回文章列表',

  // 关于我们
  about_hero_badge: '关于动漫网',
  about_brand: '品牌介绍',
  about_value: '核心价值',
  about_honor: '资质与荣誉',
  about_stats: '发展数据',
  about_contact: '联系我们',
  about_contact_sub: '有合作意向或建议？欢迎与我们联系',
  about_contact_name: '姓名',
  about_contact_email: '邮箱',
  about_contact_message: '留言内容',
  about_contact_submit: '提交留言',
  about_contact_hint: '我们会在 1-3 个工作日内回复您',
  about_submit_ok: '留言已提交，感谢您的支持！',
  about_submit_err: '提交失败，请稍后重试。',

  // 页脚
  footer_slogan: '你的二次元资源聚合站',
  footer_quick: '快速导航',
  footer_resources: '资源分类',
  footer_contact: '联系我们',
  footer_copyright: '© {year} 动漫网 版权所有',
  footer_beian: '京ICP备00000000号-1',
  footer_links: '友情链接',
  footer_tips: '本网站仅提供作品信息展示与索引，所有作品版权归原作者所有。',
} as const;